export const API_URL = process.env.REACT_APP_API_URL || 'https://api.borsaekranim.com';
export const WS_URL = process.env.REACT_APP_WS_URL || 'stream.borsaekranim.com';
